<template>
	<div class="wrapper profile">
		<div class="content">
			<div class="topbar">
				<div class="logo">
					<img src="../assets/img/bulevar-small.svg" alt="Bulevar Logo" class="logo"/>
				</div>
				<div class="info">
					<router-link to="/notifications" class="notifications">
						<div class="icon">
							<div v-if="notificationsUnread" class="counter">{{ notificationsUnread }}</div>
						</div>
						<span class="visually-hidden">{{  t('txt_notifications') }}</span>
					</router-link>
					<div class="profile">
						<router-link to="/settings"><img :src="getAvatarById(selectedAvatar)?.image || getAvatarById('1')?.image" :alt="getAvatarById(selectedAvatar)?.name  || getAvatarById('1')?.name" class="currentAvatar" /></router-link>
					</div>
				</div>
			</div>
			<h2>{{ t('txt_hello') }},</h2>
			<h1>{{ name }} {{ surname }}</h1>
		</div>
		<div class="blocks">
			<div class="tolist">
				<router-link :to="{ path: `/list` }" class="">
					{{ t('txt_earn_new_sparks') }}
				</router-link>
			</div>
			<div class="level" @click="openPopup('2024112808195090744')">
				<div class="help"></div>
				<div class="padding">
					<img src="../assets/img/level.svg" alt="level" class="animate__animated animate__headShake">
					<h3>{{ t('txt_level') }} {{ userLevel }}</h3>
					<span>{{ target }}/{{ nextLevel }}</span>
				</div>
			</div>
			<div class="invite" @click="shareContent">
				<div class="padding">
					<p>{{ t('txt_invite_text') }}</p>
					<div class="actions">
						<div class="sparkholder animate__animated animate__headShake">150</div>
						<div class="inviteaction"><button><span class="visually-hidden">{{  t('txt_invite') }}</span></button></div>
					</div>
				</div>
			</div>
			<div class="sparks" @click="openPopup('202411280826519065')">
				<div class="help"></div>
				<div class="padding">
					<div class="sparkholder">{{ t('txt_sparks') }}</div>
					<div class="values">
						<h2><CounterAni ref="counterAni" :target="target" :duration="100" /></h2>
						<div class="percentage">{{ donePercentage }}%</div>
					</div>
					<div class="progress-bar">
						<div class="progress" ref="progress"></div>
					</div>
				</div>
			</div>
		</div>
		<div class="awards">
			<div class="tabs">
			<button
					v-for="(tab, index) in tabs"
					:key="index"
					@click="activeTab = index"
					:class="{ active: activeTab === index }"
				>
					{{ tab.label }}
				</button>
			</div>

			<div v-if="loading" class="skeleton-container">
				<div class="skeleton-award">
					<div class="skeleton-info">
						<div class="skeleton-title animate__animated animate__pulse animate__infinite"></div>
						<div class="skeleton-location animate__animated animate__pulse animate__infinite"></div>
						<div class="skeleton-date animate__animated animate__pulse animate__infinite"></div>
					</div>
					<div class="skeleton-image"></div>
				</div>
			</div>
			<Splide v-else-if="awards && awards.length" :options="splideOptions" aria-label="Awards">
				<SplideSlide v-for="award in awards" :key="award.id">
					<router-link v-if="award.type !== 'used'" :to="{ path: `/award/${award.id}` }" class="award">
						<div class="padding">
							<div class="wrap">
								<div class="info">
									<h2>{{ award.title }}</h2>
									<div class="location" v-html="t('txt_at')+' '+award.partner_title"></div>
									<div class="timeframe">{{ t('txt_until') }} {{ formatDate(award.date, 'L') }}</div>
								</div>
								<!-- <div class="image">
									<img :src="award.image" alt="Award image">
								</div> -->
							</div>
						</div>
					</router-link>
					<span v-else class="award disabled">
						<div class="padding">
							<div class="wrap">
								<div class="info">
									<h2>{{ award.title }}</h2>
									<div class="location" v-html="t('txt_at')+' '+award.partner_title"></div>
									<div class="timeframe">{{ t('txt_used') }} {{ formatDate(award.used_date, 'L') }}</div>
								</div>
								<!-- <div class="image">
									<img :src="award.image" alt="Award image">
								</div> -->
							</div>
						</div>
					</span>
				</SplideSlide>
			</Splide>
			<div v-else class="noawards">
				<div class="padding">
					<div class="wrap">
						<div class="icon"></div>
						<div class="info">
							<p v-html="t('txt_no_awards')"></p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div v-if="state.show" class="fullscreen-popup">
		<button @click="closePopup" class="close"><span class="visually-hidden">Close</span></button>
		<div class="popup-content">
			<img src="../assets/img/bulevar-small.svg" alt="Bulevar Logo" />
			<h1>{{ state.title }}</h1>
			<div v-html="state.description" class="description"></div>
		</div>
	</div>
	<MobileNav :selected="selectedId" />
</template>

<script>
import { keycloak } from '../keycloak';
import { useI18n } from 'vue-i18n';
import apiClient from '../utils/axios';
import '@splidejs/vue-splide/css';
import dayjs from '@/utils/dayjs';

export default {
	name: 'ProfilePage',
	data() {
		return {
			selectedId: 3,
			username: keycloak.tokenParsed?.preferred_username || 'User',
			name: keycloak.tokenParsed?.given_name || 'Name',
			surname: keycloak.tokenParsed?.family_name || 'Surname',
			selectedAvatar: null,
			lang : localStorage.getItem('lang') || 'en',
			tabs: [
				{ label: this.t('txt_awards'), endpoint: `/${localStorage.getItem('lang')}/api/awards`, type: 'current' },
				{ label: this.t('txt_awards_used'), endpoint: `/${localStorage.getItem('lang')}/api/awards/used`, type: 'used' },
			],
			activeTab: 0,
			awards: [],
			loading: false,
			nextLevel: 0,
			splideOptions: {
				rewind: true,
				gap: '10px',
				padding: { left: 30, right: 30 },
				arrows: false,
			},
			avatars: [
				{ id: '1', image: require('../assets/img/eda-spomenik.svg'), name: 'eda-spomenik' },
				{ id: '2', image: require('../assets/img/goriska-vrtnica.svg'), name: 'goriska-vrtnica' },
				{ id: '3', image: require('../assets/img/goriski-grad.svg'), name: 'goriski-grad' },
				{ id: '4', image: require('../assets/img/soca.svg'), name: 'soca' },
				{ id: '5', image: require('../assets/img/solkanski-most.svg'), name: 'solkanski-most' },
				{ id: '6', image: require('../assets/img/solkanski-radic.svg'), name: 'solkanski-radic' },
				{ id: '7', image: require('../assets/img/soska-postrv.svg'), name: 'postrv' },
				
			],
			target: 0,
			notificationsUnread: 0,
			maxTarget: 0,
			donePercentage: 0,
			userLevel: 0,
			state: {
				show: false
			}
		};
	},
	setup() {
		const { t, locale } = useI18n();

		const changeLanguage = (newLocale) => {
			locale.value = newLocale;
			localStorage.setItem('lang', newLocale);
		};
		
		return {
			changeLanguage,
			t
		};
	},
	methods: {
		handlePopstate() {
			if (this.state.show) {
				this.closePopup();
			}
		},
		openPopup(contentId) {
			const lang = localStorage.getItem('lang') || 'en';
			const apiUrl = `/${lang}/api/content/${contentId}/view`;
			
			apiClient.get(apiUrl, {noAuth:true})
				.then(response => {
					this.state.title = response.data.title;
					this.state.description = response.data.description;
					this.state.show = true;
			}).catch(apiError => {
					console.error('Failed to send user data:', apiError);
					this.loading = false;
			});
			history.pushState({ popup: true }, '', '');
			window.addEventListener('popstate', this.handlePopstate);

		},
		closePopup() {
			this.state.show = false;
			window.removeEventListener('popstate', this.handlePopstate);
			history.replaceState(null, '', '');
		},
		getAvatarById(id) {
			return this.avatars.find(avatar => avatar.id === id);
		},
		async fetchAwards(endpoint) {
			this.loading = true;
			try {
				const response = await apiClient.get(endpoint);
				this.awards = response.data;
			} catch (error) {
				console.error("Error fetching awards:", error);
				this.awards = [];
			} finally {
				this.loading = false;
			}
		},
		setActiveTab(index) {
			if (index >= 0 && index < this.tabs.length) {
				this.activeTab = index;
				this.fetchAwards(this.tabs[index].endpoint);
			}
		},
		async shareContent() {
			if (navigator.share) {
				try {
					await navigator.share({
						title: this.t('txt_share_title'),
						text: this.t('txt_share_description'),
						url: 'https://'+window.location.hostname,
					});
					const response = await apiClient.get(`/${this.lang}/api/user/share`);
					if(response.data.error == false){
						this.setActiveTab(0);
					}
				} catch (err) {
					console.error('Error sharing content:', err);
				}
			} else {
				console.error('Web Share API is not available on this device.');
			}
		},
		updateTarget(newTargetValue) {
			this.target = newTargetValue;
		},
		formatDate(date, format ='L LT') {
			return dayjs(date).locale(localStorage.getItem('lang')).format(format);
		}
	},
	computed: {
		filteredAwards() {
			const activeTab = this.tabs[this.activeTab];
			return activeTab ? this.awards.filter(activeTab.filter) : this.awards;
		},
	},
	mounted() {
		this.isAuthenticated = keycloak.authenticated;
		if (this.isAuthenticated) {
			const userData = {
				username: keycloak.tokenParsed.preferred_username,
				last_name: keycloak.tokenParsed?.family_name || 'Surname',
				first_name: keycloak.tokenParsed?.given_name || 'Name',
				email: keycloak.tokenParsed.email,
				keycloak_id: keycloak.tokenParsed.sub
			};
			apiClient.post('/'+localStorage.getItem('lang')+'/api/user', userData)
				.then(response => {
					if(localStorage.getItem('avatar') == null){
						localStorage.setItem('avatar', response.data.avatar);
					}
					this.selectedAvatar = response.data.avatar ?? localStorage.getItem('avatar');
					this.fetchAwards(this.tabs[this.activeTab].endpoint);
					if(response.data.country_iso_code == null){
						this.$router.push('/questionare');
					}
					this.updateTarget(response.data.score);
					this.notificationsUnread = response.data.notificationsUnread;
					this.userLevel = response.data.userLevel;
					this.maxTarget = response.data.maxTarget;
					this.nextLevel = response.data.nextLevel;
					this.donePercentage = Math.round((response.data.score * 100 ) / response.data.maxTarget);
					if(this.donePercentage > 100){
						this.donePercentage = 100;
					}
					this.$refs.progress.style.width = this.donePercentage+'%';
				})
				.catch(apiError => {
					console.error('Failed to send user data:', apiError);
				});
		}
	},
	watch: {
		activeTab(newTabIndex) {
			this.fetchAwards(this.tabs[newTabIndex].endpoint);
		},
		target() {
			this.$refs.counterAni.updateCounting();
		}
	},
};
</script>

<style>
.splide {
	min-height: 200px;
}
.splide__track {
	height: 200px;
}
.splide__slide {
	display: flex;
    flex-direction: column;
    height: 100%;
}
.splide__list {
	align-items: stretch;
}
.splide__pagination {
	bottom: -25px;
	.splide__pagination__page.is-active {
		width: 40px;
		height: 8px;
		border-radius: 4px;
		background: #29CCB1;
		transform: scale(1);
	}
	.splide__pagination__page {
		width: 8px;
		height: 8px;
		border-radius: 4px;
		background: #656771;
		transform: scale(1);
		opacity: 1;
	}
}
</style>
